import {createSelector} from 'reselect';

export const selectIpCountryCode = state => state.get('ipCountryCode');
export const selectAccountCountryCode = state => state.getIn(['account', 'account', 'country']);
export const selectCountryCode = state =>
    selectAccountCountryCode(state) || selectIpCountryCode(state);
export const selectLocale = state => state.getIn(['localization', 'locale']);
export const selectMessageProperties = state => state.getIn(['localization', 'messageProperties']);
export const selectSupportedLocales = state => state.getIn(['localization', 'supportedLocales']);

export const selectSupportedLocalesAsList = createSelector(
    selectSupportedLocales,
    locales => locales.map(l => l.get('lang')).toJS()
);
